import { GoogleMapCustom } from '@organisms/google-map';
import { googleMapStatic } from '@pages/offer-page/static-map/google-map-static';
import { googlePlacesHelpers } from '@tools/geoservices/google-places-helpers';

export const staticMap = () => {
  window.addEventListener('load', () => {
    const mapScript = document.getElementById('__googleMapsScriptId');

    const script = mapScript || googlePlacesHelpers.initLib();
    script.addEventListener('load', () => {
      document.querySelectorAll('[data-google-map-static="on"]').forEach(
        (el) => googleMapStatic(el),
      );

      document.querySelectorAll('[data-google-map-static-button="on"]').forEach((el) => {
        const map = new GoogleMapCustom(el);
        map.renderStatic();
      });
    });
  });
};
